import { supabase } from './supabase';

const BADGES = [
  {
    type: 'premiere_sortie',
    emoji: '🌱',
    label: 'Première sortie',
    description: 'A créé sa première activité',
    check: async (userId) => {
      const { count } = await supabase.from('activites').select('*', { count: 'exact', head: true }).eq('user_id', userId);
      return count >= 1;
    }
  },
  {
    type: 'famille_active',
    emoji: '🌿',
    label: 'Famille Active',
    description: '3 activités créées',
    check: async (userId) => {
      const { count } = await supabase.from('activites').select('*', { count: 'exact', head: true }).eq('user_id', userId);
      return count >= 3;
    }
  },
  {
    type: 'pilier_quartier',
    emoji: '🌳',
    label: 'Pilier du quartier',
    description: '5 activités créées',
    check: async (userId) => {
      const { count } = await supabase.from('activites').select('*', { count: 'exact', head: true }).eq('user_id', userId);
      return count >= 5;
    }
  },
  {
    type: 'bien_note',
    emoji: '⭐',
    label: 'Bien noté',
    description: 'Note moyenne supérieure à 4',
    check: async (userId) => {
      const { data } = await supabase
        .from('notations')
        .select('note, activites(user_id)')
        .eq('activites.user_id', userId);
      if (!data || data.length < 2) return false;
      const moyenne = data.reduce((sum, n) => sum + n.note, 0) / data.length;
      return moyenne >= 4;
    }
  },
  {
    type: 'super_parent',
    emoji: '👨‍👩‍👧',
    label: 'Super Parent',
    description: '5 participations à des activités',
    check: async (userId) => {
      const { count } = await supabase.from('participations').select('*', { count: 'exact', head: true }).eq('user_id', userId);
      return count >= 5;
    }
  },
  {
    type: 'explorateur',
    emoji: '🗺️',
    label: 'Explorateur',
    description: 'A participé à 3 types d\'activités différents',
    check: async (userId) => {
      const { data } = await supabase
        .from('participations')
        .select('activites(type)')
        .eq('user_id', userId);
      if (!data) return false;
      const types = new Set(data.map(p => p.activites?.type).filter(Boolean));
      return types.size >= 3;
    }
  },
];

export const verifierEtAttribuerBadges = async (userId) => {
  if (!userId) return [];
  try {
    const { data: badgesExistants } = await supabase
      .from('badges')
      .select('type')
      .eq('user_id', userId);
    
    const typesExistants = new Set(badgesExistants?.map(b => b.type) || []);
    const nouveauxBadges = [];

    for (const badge of BADGES) {
      if (typesExistants.has(badge.type)) continue;
      const eligible = await badge.check(userId);
      if (eligible) {
        await supabase.from('badges').insert({ user_id: userId, type: badge.type });
        nouveauxBadges.push(badge);
      }
    }
    return nouveauxBadges;
  } catch (err) {
    console.error('Erreur badges:', err);
    return [];
  }
};

export const getBadgesUtilisateur = async (userId) => {
  if (!userId) return [];
  const { data } = await supabase.from('badges').select('*').eq('user_id', userId);
  return (data || []).map(b => {
    const badge = BADGES.find(bd => bd.type === b.type);
    return { ...b, ...badge };
  });
};

export const BADGES_INFO = BADGES;